import getApiClient from '@/plugins/api-client'

export default {
  loadCategories () {
    const api = getApiClient(this.$store)

    api.get('categories')
      .then(result => {
        this.pagination.updateData(result.data)
        this.categories = result.data['hydra:member']
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (categoryId) {
    this.showDeleteDialog = true
    this.deletingId = categoryId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Categoria excluída')
          this.loadCategories()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir categoria')
        this.loadCategories()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
